export default "__VITE_ASSET__HPZIslog__"